var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPoll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.25,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EBF9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 15.55C11 13.8698 11 13.0298 11.327 12.388C11.6146 11.8235 12.0735 11.3646 12.638 11.077C13.2798 10.75 14.1198 10.75 15.8 10.75H24.2C25.8802 10.75 26.7202 10.75 27.362 11.077C27.9265 11.3646 28.3854 11.8235 28.673 12.388C29 13.0298 29 13.8698 29 15.55V21.25C29 22.6478 29 23.3467 28.7716 23.8981C28.4672 24.6331 27.8831 25.2172 27.1481 25.5216C26.5967 25.75 25.8978 25.75 24.5 25.75C24.0114 25.75 23.7671 25.75 23.5405 25.8035C23.2383 25.8748 22.9569 26.0156 22.7185 26.2145C22.5397 26.3637 22.3931 26.5591 22.1 26.95L20.64 28.8967C20.4229 29.1862 20.3143 29.3309 20.1812 29.3827C20.0647 29.428 19.9353 29.428 19.8188 29.3827C19.6857 29.3309 19.5771 29.1862 19.36 28.8967L17.9 26.95C17.6069 26.5591 17.4603 26.3637 17.2815 26.2145C17.0431 26.0156 16.7617 25.8748 16.4595 25.8035C16.2329 25.75 15.9886 25.75 15.5 25.75C14.1022 25.75 13.4033 25.75 12.8519 25.5216C12.1169 25.2172 11.5328 24.6331 11.2284 23.8981C11 23.3467 11 22.6478 11 21.25V15.55Z",
    stroke: "#2A9BCB",
    strokeWidth: 2.05556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15.75V20.75",
    stroke: "#2A9BCB",
    strokeWidth: 2.05556,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18.75V20.75",
    stroke: "#2A9BCB",
    strokeWidth: 2.05556,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 17.25V20.75",
    stroke: "#2A9BCB",
    strokeWidth: 2.05556,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPoll);
export default __webpack_public_path__ + "static/media/icon-poll.b769aad3d125276cb915bc54be5245699ead3521700c1c3041a7fb92f9f6a66f.svg";
export { ForwardRef as ReactComponent };